function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/filter";
import "rxjs/add/operator/share";
var API = /*#__PURE__*/ function() {
    "use strict";
    function API() {
        _classCallCheck(this, API);
        this._providers = [];
        this._lastUid = 0;
    }
    var _proto = API.prototype;
    // Returns an object:
    //  .observable => the observable, where I get messages
    //  .write      => a function to communicate to the providers.
    _proto.connect = function connect() {
        var _this = this;
        var _Observable;
        console.warn("You are using Extension API version 1 which is depricated and is no longer maintained. Please update to version 3!");
        var uid = String(++this._lastUid);
        var source = (_Observable = Observable).merge.apply(_Observable, _toConsumableArray(this._providers.map(function(provider) {
            return provider.getObservable();
        }))).filter(function(msg) {
            // Filter messages for current observer
            return msg.client === uid;
        }).map(function(msg) {
            // Cleanup message for observers
            delete msg.client;
            return msg;
        }).share();
        return {
            write: function(channel, d, options) {
                _this._providers.forEach(function(p) {
                    return p.write(uid, {
                        type: channel,
                        data: d,
                        options: options
                    });
                });
            },
            source: source
        };
    };
    // This function will be used to (re-)initialize the Extension API
    //  e.g.: on Chart Change or something like this:
    _proto.initialize = function initialize(providers) {
        this._dispose();
        // The Providers are already initialized, but needed to be tracked now:
        this._providers = providers;
    };
    // Cleanup
    _proto._dispose = function _dispose() {
        // Reset existing providers:
        this._providers.forEach(function(provider) {
            return provider.release();
        });
        this._providers = [];
    };
    return API;
}();
export default {
    expose: function(scope) {
        scope = scope || {};
        if (!scope.ExtensionAPI) {
            scope.ExtensionAPI = new API();
        }
        return scope;
    },
    remove: function(scope) {
        scope.ExtensionAPI._dispose();
        scope.ExtensionAPI = null;
        delete scope.ExtensionAPI;
    }
};
